export interface CopilotFixDialogSubmitOptions {
  createPullRequest: boolean
  instructions: string
  model: string
}

export interface KnownBillingEntityError {
  match: string
  message: string
  docsLink: string
  settingsPath: string
}

export class FixWithCopilotError extends Error {
  override name = 'FixWithCopilotError'
  knownError?: KnownBillingEntityError
  constructor(message: string, knownError?: KnownBillingEntityError) {
    super(message)
    this.knownError = knownError
  }
}
